import { useState, useEffect } from "react";

import wlOebbHalf from "../routes/newApp/assets/wl-oebb-half.jpeg";
import wlOebbFull from "../routes/newApp/assets/wl-oebb-full.jpeg";
import wlFellbachHalf from "../routes/newApp/assets/wl-fellbach-half.jpeg";
import wlFellbachFull from "../routes/newApp/assets/wl-fellbach-full.jpeg";
import wlAllgaeuHalf from "../routes/newApp/assets/wl-allgaeu-half.jpeg";
import wlAllgaeuFull from "../routes/newApp/assets/wl-allgaeu-full.jpeg";
import wlBikeboxHalf from "../routes/newApp/assets/wl-bikebox-half.jpeg";
import wlBikeboxFull from "../routes/newApp/assets/wl-bikebox-full.jpeg";
import wlPurkersdorfHalf from "../routes/newApp/assets/wl-purkersdorf-half.jpeg";

export type Slide = { src: string; label: string };

/** The 9 partial-whitelabel frames, shared by the home and app pages. */
export const PARTIAL_SLIDES: Slide[] = [
  { src: wlOebbHalf, label: "ÖBB Bike:Parking" },
  { src: wlOebbFull, label: "ÖBB Bike:Parking" },
  { src: wlFellbachHalf, label: "Fellbach.go! · Turm C" },
  { src: wlFellbachFull, label: "Fellbach.go! · Turm C" },
  { src: wlAllgaeuHalf, label: "Allgäutissimo Bikeshop" },
  { src: wlAllgaeuFull, label: "Allgäutissimo Bikeshop" },
  { src: wlBikeboxHalf, label: "BikeBox 03" },
  { src: wlBikeboxFull, label: "BikeBox 03" },
  { src: wlPurkersdorfHalf, label: "Purkersdorf" },
];

/** Auto-rotating phone slider with a live caption and dot navigation. */
export default function PhoneStage({
  slides,
  single = false,
  showDots = true,
  height = 580,
}: {
  slides: Slide[];
  single?: boolean;
  showDots?: boolean;
  height?: number;
}) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (single) return;
    const reduce = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (reduce) return;
    const timer = setInterval(
      () => setIndex((p) => (p + 1) % slides.length),
      2600
    );
    return () => clearInterval(timer);
  }, [single, slides.length]);

  return (
    <div className="relative flex flex-col items-center">
      <div className="pointer-events-none absolute top-5 left-8 h-72 w-72 rounded-full bg-juhuu-glow blur-[90px]" />
      <div className="relative z-10 w-[300px] max-w-full rounded-[42px] bg-ink p-2.5 shadow-2xl">
        <div
          className="relative overflow-hidden rounded-[33px] bg-[#0b0a0f]"
          style={{ height }}
        >
          {slides.map((s, i) => (
            <img
              key={i}
              src={s.src}
              alt={s.label}
              loading="lazy"
              className={`absolute inset-0 h-full w-full object-cover object-top transition-opacity duration-700 ${
                i === index ? "opacity-100" : "opacity-0"
              }`}
            />
          ))}
          {slides[index].label && (
            <div className="absolute bottom-3.5 left-1/2 z-20 -translate-x-1/2 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-black/75 px-3 py-1.5 text-xs font-semibold text-white backdrop-blur">
              <span className="h-1.5 w-1.5 rounded-full bg-[#5fe3a8] ring-4 ring-[#5fe3a8]/25" />
              {slides[index].label}
            </div>
          )}
        </div>
      </div>
      {!single && showDots && (
        <div className="mt-4 flex max-w-[280px] flex-wrap justify-center gap-1.5">
          {slides.map((_, i) => (
            <button
              key={i}
              type="button"
              aria-label={`Slide ${i + 1}`}
              onClick={() => setIndex(i)}
              className={`h-[7px] rounded-full transition-all ${
                i === index ? "w-5 bg-juhuu" : "w-[7px] bg-line-strong"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
